/**
 * TanStack Query Client Configuration
 *
 * This is the "smart memory" that remembers API answers
 * so we don't ask the same question twice!
 */

import { QueryClient } from '@tanstack/react-query'
import { API_BASE } from '../services/api'

// Gateway URL from environment
export const GATEWAY_URL =
  import.meta.env.VITE_GATEWAY_URL ||
  API_BASE

// Create the query client with sensible defaults
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is "fresh" for 30 seconds before we consider refetching
      staleTime: 30 * 1000,

      // Keep unused data in cache for 5 minutes
      gcTime: 5 * 60 * 1000,

      // Retry failed requests up to 2 times
      retry: 2,

      // Refetch when window regains focus (user comes back to tab)
      refetchOnWindowFocus: true,

      // Don't refetch on component mount if data is fresh
      refetchOnMount: true,
    },
    mutations: {
      // Retry mutations once on failure
      retry: 1,
    },
  },
})

